import React, { useEffect } from 'react';
import './style.sass';
import { useHistory } from 'react-router-dom';

import { Header } from 'pages/Header'
import { Footer } from 'pages/Footer'
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito'
import { TitlePage } from 'components/General/TitlePage'
import { MenuCredito } from 'components/menuCredito'
import { TarjetaSears } from 'components/AgregarTarjetaSears'

import { useIsMobile } from 'hooks/useIsMobile'
import { useAddCard } from 'hooks/useAddCard'
import { Error500 } from 'components/Error/Error500'


export default function AgregarTarjeta() {
    const history = useHistory();
    const { isMobile } = useIsMobile()

    const { addNewCard, errorCode} = useAddCard()

    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        // window.ineum('page', 'Add Sears Card Credit-Page')
        // window.ineum('meta', 'portal', 'Credito')
    },[])

    return (
        <>
            {isMobile
                ? isMobile === 'desktop' 
                    ? <Header type="complete"/>
                    : <HeaderMobileCredito title={"Agregar tarjeta"} type="backFull" btnTypeR="floatMenu" />
                : null
            }

            <div className={isMobile === 'desktop' ? "container"  : null}>
                <div className="contPlanPayments">
                    <MenuCredito />
                    {errorCode >= 500
                        ? <Error500 />
                        :
                            <div className="contPlanes">
                                <TitlePage title="Agregar tarjeta" />
                                <TarjetaSears setAddCard={addNewCard} errorCode={errorCode}/>
                            </div>
                    }
                </div>
            </div>

            {isMobile
                ? isMobile === 'desktop'
                    ? <Footer type="complete"/>
                    : null
                : null
            }
        </>
    )
}